import React, { createContext, useContext, useReducer } from 'react';
import reducer, { initialState } from './reducer';

const GlobalStore = createContext({});

export const useStore = selector => {
  const { state: globalState, dispatch } = useContext(GlobalStore);
  const state = selector ? selector(globalState) : globalState;
  return { state, dispatch };
};

export const useSelector = selector => useStore(selector).state;
export const useDispatch = () => useStore().dispatch;

export default ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <GlobalStore.Provider value={{ state, dispatch }}>{children}</GlobalStore.Provider>;
};



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/store/store.js